import { apiService } from '@clarix/api-client';
import { supportBase } from '../lib/base';
import { SUPPORT_ENDPOINTS } from '../endpoints';
import type { SupportMe, PendingApproval, MyTeam } from '../types';

export const meApi = {
  permissions: () => apiService.get<SupportMe>(`${supportBase()}${SUPPORT_ENDPOINTS.ME_PERMISSIONS}`),
  pendingApprovals: () => apiService.get<PendingApproval[]>(`${supportBase()}${SUPPORT_ENDPOINTS.ME_PENDING_APPROVALS}`),
  /** The teams the caller is on (My Teams surface + membership-gated UI signal). */
  teams: () => apiService.get<MyTeam[]>(`${supportBase()}${SUPPORT_ENDPOINTS.ME_TEAMS}`),
};
